import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  categories: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "category",
  initialState,
  reducers: {
    getCategorySuccess: (state, { payload }) => {
      state.categories = payload;
      state.loading = false;
    },
    startLoadingCategory: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllCategroy = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingCategory());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-category`,
        { headers }
      );
      dispatch(slice.actions.getCategorySuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};

export const getCategory = async ({ accessToken }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  const res = await axios.get(
    `${process.env.REACT_APP_BACKEND_API}/get-all-category`,
    { headers }
  );
  return res.data;
};
